import { connect } from 'react-redux'
import FirestoreChannel from '../components/firestore-messages/firestore-channel'

const mapStateToProps = state => ({
  ...state.firestoreChannel
})

const mapDispatchToProps = dispatch => ({
  loadMessages: payload => dispatch({type: 'FIRESTORE_CHANNEL.LOAD', payload}),
  sendMessage: payload => dispatch({type: 'FIRESTORE_CHANNEL.SEND', payload}),
  sendFile: payload => dispatch({type: 'FIRESTORE_CHANNEL.SEND_FILE', payload}),
  deleteMessage: payload => dispatch({type: 'FIRESTORE_CHANNEL.DELETE', payload}),
  setScrollAndLimit: payload => dispatch({type: 'FIRESTORE_CHANNEL.SET_SCROLL_AND_LIMIT', payload})
})

export default connect(mapStateToProps, mapDispatchToProps)(FirestoreChannel)
